// extracted by mini-css-extract-plugin
module.exports = {"title_wrapper":"SignInStyle_title_wrapper__2nX5J","forgot_password":"SignInStyle_forgot_password__1KQkA","errorWrap":"SignInStyle_errorWrap__2Ne-x"};